import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { Observable } from 'rxjs';

import { ConfirmationService } from '@openng/optimus-ui/api';

import type { DatabaseDemoComponent } from 'src/app/components/database-demo/database-demo.component';

/**
 * Warns the user before an in-app (router) navigation away from the database demo while queries are running.
 * The `beforeunload` handler on {@link DatabaseDemoComponent} only covers tab close/reload.
 * @param component Database demo page being left.
 * @returns Whether navigation may continue.
 */
export const databaseDemoRunningGuard: CanDeactivateFn<DatabaseDemoComponent> = component => {
	if (!component.runner.busy()) {
		return true;
	}

	const confirmationService = inject(ConfirmationService);

	return new Observable<boolean>(subscriber => {
		confirmationService.confirm({
			message: 'Queries are still running. Do you want to leave this page? Results of the running queries will be lost.',
			header: 'Confirm navigation',
			icon: 'pi pi-exclamation-triangle',
			acceptButtonStyleClass: 'p-button-danger',
			rejectButtonStyleClass: 'p-button-secondary p-button-outlined',
			acceptIcon: 'none',
			rejectIcon: 'none',
			accept: () => {
				subscriber.next(true);
				subscriber.complete();
			},
			reject: () => {
				subscriber.next(false);
				subscriber.complete();
			},
		});
	});
};
